import {FC} from 'react';
import {styled} from 'styled-components';
import {useParams} from 'wouter';

import {NonEmptyArray} from '@shared/lib/utils/type_utils';

import {useResponsive} from '@shared_web/breakpoints';

import {Loader} from '@mavismart_frontend/components/loader';
import {NavigationTab, NavigationTabs} from '@mavismart_frontend/components/navigation_tabs';
import {DoorsList} from '@mavismart_frontend/pages/tabs/doors_list';
import {UserCollaborators} from '@mavismart_frontend/pages/tabs/group_collaborators';
import {GroupInfo} from '@mavismart_frontend/pages/tabs/group_info';
import {useGroups} from '@mavismart_frontend/stores/groups_store';

export const GroupTabs: FC = () => {
  const {groupId} = useParams<{groupId: string}>();
  const {isMobile, isTablet} = useResponsive();
  const fullGroups = useGroups();
  const fullGroup = fullGroups?.find(g => g.group.id === groupId);

  if (!fullGroup) {
    return <Loader />;
  }

  const tabs: NonEmptyArray<NavigationTab> = [
    {
      path: `/groups/${groupId}/info`,
      label: 'info',
      view: <GroupInfo group={fullGroup} />,
      default: true,
    },
  ];

  if (isMobile || isTablet) {
    tabs.push({
      path: `/groups/${groupId}/doors`,
      label: 'doors',
      view: <DoorsList doorIds={fullGroup.doorIds} />,
    });
  }
  if (fullGroup.permission === 'admin') {
    tabs.push({
      path: `/groups/${groupId}/sharing`,
      label: 'sharing',
      view: <UserCollaborators groupId={fullGroup.group.id} />,
    });
  }

  return (
    <Wrapper>
      <NavigationTabs tabs={tabs} />
    </Wrapper>
  );
};

GroupTabs.displayName = 'GroupTabs';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
